import React, { useEffect, useState } from "react";
import Table from "../../../../common/element/Table";
import Tag from "../../../../common/element/Tag";
import { useSelector } from "react-redux";
import Tooltip from "../../../../common/element/Tooltip";
import Dialog from "../../../../common/element/Dialog/Dialog";
import Tabs from "../../../../common/element/Tabs";
import Documents from "./Documents";
import ClientDetails from "./ClientDetails";
import ConnectedWorkers from "./ConnectedWorkers";
import BtnLight from "../../../../common/element/Buttons/btnLight";
import BtnPrimary from "../../../../common/element/Buttons/btnPrimary";
import Button from "../../../../common/element/Buttons";
import { reject } from "lodash";
import moment from "moment";
import PdfData from "./pdf/Index";
import PdfDataView from "../../../../common/pdfView/Index";
const { TabNav, TabList, TabContent } = Tabs;
const ClientsList = (props) => {
  const [clientData, setClientData] = useState(null);
  const [indivisualData, setIndivisualData] = useState(null);
  const { Tr, Th, Td, THead, TBody } = Table;

  let { AllClientsOfAdminProvider } = useSelector((state) => state);
  useEffect(() => {
    setClientData(AllClientsOfAdminProvider?.data?.data?.rows);
  }, [AllClientsOfAdminProvider]);

  const [dialogIsOpen, setIsOpen] = useState(false);

  const openDialog = (item) => {
    setIndivisualData(item);
    setIsOpen(true);
  };

  const onDialogClose = (e) => {
    setIsOpen(false);
    props?.setRefetch(!props?.refetch);
  };

  const onDialogOk = (e) => {
    setIsOpen(false);
  };
  const loginUserData = JSON.parse(localStorage.getItem("LoginUserData"));
  return (
    <React.Fragment>
      <div className="overflow-hidden border rounded-lg border-gray-200">
        <Table>
          <THead>
            <Tr  >
              <Th>
                <span
                  className="flex items-center gap-1"
                // onClick={() =>
                //   props.handleSort(
                //     props.getAllinvitedData.type == "clientContact"
                //       ? "contact_first_name"
                //       : "first_name"
                //   )
                // }
                >
                  Status
                  <Tooltip
                    title="Status"
                    placement="top-start"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <g clip-path="url(#clip0_7297_80902)">
                        <path
                          d="M6.05992 5.99992C6.21665 5.55436 6.52602 5.17866 6.93322 4.93934C7.34042 4.70002 7.81918 4.61254 8.2847 4.69239C8.75022 4.77224 9.17246 5.01427 9.47664 5.3756C9.78081 5.73694 9.94729 6.19427 9.94659 6.66659C9.94659 7.99992 7.94659 8.66659 7.94659 8.66659M7.99992 11.3333H8.00659M14.6666 7.99992C14.6666 11.6818 11.6818 14.6666 7.99992 14.6666C4.31802 14.6666 1.33325 11.6818 1.33325 7.99992C1.33325 4.31802 4.31802 1.33325 7.99992 1.33325C11.6818 1.33325 14.6666 4.31802 14.6666 7.99992Z"
                          stroke="#98A2B3"
                          stroke-width="1.33333"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_7297_80902">
                          <rect width="16" height="16" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </Tooltip>
                </span>
              </Th>
              <Th>
                <span
                  className="flex items-center gap-1"
                  onClick={() => props.handleSort("trading_name")}
                >
                  Client name
                  <svg
                    className={`transform ${props?.getAllinvitedData?.sort === "trading_name" && props?.getAllinvitedData?.order === "asc"
                      ? "rotate-180"
                      : ""
                      }`}
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.712 3.333v9.334m0 0L13.38 8m-4.667 4.667L4.045 8"
                      stroke="#475467"
                      strokeWidth="1.333"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
              </Th>
              <Th className="w-96">
                <span className="flex items-center gap-1"
                  onClick={() => props.handleSort("email")}>Email
                  <svg
                    className={`transform ${props?.getAllinvitedData?.sort === "email" && props?.getAllinvitedData?.order === "asc"
                      ? "rotate-180"
                      : ""
                      }`}
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.712 3.333v9.334m0 0L13.38 8m-4.667 4.667L4.045 8"
                      stroke="#475467"
                      strokeWidth="1.333"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>

                </span>
              </Th>
              <Th className="w-44">
                <span className="flex items-center gap-1" onClick={() => props.handleSort("phone")}>Phone number

                  <svg
                    className={`transform ${props?.getAllinvitedData?.sort === "phone" && props?.getAllinvitedData?.order === "asc"
                      ? "rotate-180"
                      : ""
                      }`}
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.712 3.333v9.334m0 0L13.38 8m-4.667 4.667L4.045 8"
                      stroke="#475467"
                      strokeWidth="1.333"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
              </Th>
              <Th>Assigned</Th>
              <Th>
                <span
                  className="flex items-center gap-1"
                // onClick={() =>
                //   props.handleSort(
                //     props.getAllinvitedData.type == "clientContact"
                //       ? "contact_first_name"
                //       : "first_name"
                //   )
                // }
                >
                  Documents
                  <Tooltip
                    title="Documents"
                    placement="top-start"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <g clip-path="url(#clip0_7297_80902)">
                        <path
                          d="M6.05992 5.99992C6.21665 5.55436 6.52602 5.17866 6.93322 4.93934C7.34042 4.70002 7.81918 4.61254 8.2847 4.69239C8.75022 4.77224 9.17246 5.01427 9.47664 5.3756C9.78081 5.73694 9.94729 6.19427 9.94659 6.66659C9.94659 7.99992 7.94659 8.66659 7.94659 8.66659M7.99992 11.3333H8.00659M14.6666 7.99992C14.6666 11.6818 11.6818 14.6666 7.99992 14.6666C4.31802 14.6666 1.33325 11.6818 1.33325 7.99992C1.33325 4.31802 4.31802 1.33325 7.99992 1.33325C11.6818 1.33325 14.6666 4.31802 14.6666 7.99992Z"
                          stroke="#98A2B3"
                          stroke-width="1.33333"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_7297_80902">
                          <rect width="16" height="16" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </Tooltip>
                </span>
              </Th>
            </Tr>
          </THead>
          <TBody>
            {!props?.loader &&
              clientData?.map((item, index) => {
                // let status;
                // let assigned;
                // const approvalStatusArray = item?.ClientChklist?.flatMap((item) =>
                //   item?.ProvCheckDoc?.filter((doc) => doc)?.map((doc) =>
                //     doc.DocAppr !== null ? doc.DocAppr.approval_status : "pending"
                //   )
                // );

                // const assignedStatusArray = item?.ClientChklist?.flatMap((item) =>
                //   item?.ProvCheckDoc?.filter((doc) => doc)?.map((doc) =>
                //     doc.DocAppr !== null ? doc.DocAppr.approval_status : "null"
                //   )
                // );

                // const reviewed_date = item?.ClientChklist?.flatMap((item) =>
                //   item?.ProvCheckDoc?.filter((doc) =>
                //     doc?.DocAppr?.reviewed_date
                //       ? doc.DocAppr?.reviewed_date !== "null" &&
                //         doc?.DocAppr?.reviewed_date !== null
                //       : ""
                //   )?.map(
                //     (doc) =>
                //       doc?.DocAppr !== null &&
                //       doc?.DocAppr !== "null" &&
                //       doc.DocAppr?.reviewed_date
                //   )
                // );

                // // Convert date strings to Date objects
                // const latestDate =reviewed_date.length&&new Date(
                //   Math.max(
                //     ...reviewed_date?.map((dateString) => new Date(dateString))
                //   )
                // );
                // if (
                //   assignedStatusArray.every((status) => status === "admin_reject")
                // ) {
                //   assigned = "Rejected";
                // } else if (
                //   assignedStatusArray.every((status) => status === "approved")
                // ) {
                //   assigned = moment(latestDate).format("DD/MM/YYYY");
                // } else if (
                //   assignedStatusArray.includes("null") ||
                //   assignedStatusArray.includes("client_approval_req")
                // ) {
                //   assigned = "Unassigned";
                // }

                // if (approvalStatusArray?.includes("client_approval_req")) {
                //   status = "Action required";
                // } else if (
                //   approvalStatusArray?.length == 2 &&
                //   approvalStatusArray?.includes("approved") &&
                //   approvalStatusArray?.includes("client_approved_action")
                // ) {
                //   status = "Approved";
                // } else if (
                //   approvalStatusArray?.every(
                //     (status) => status === "admin_approved"
                //   )
                // ) {
                //   status = "Approved";
                // } else if (
                //   approvalStatusArray?.every(
                //     (status) => status === "client_approved"
                //   )
                // ) {
                //   status = "Approved";
                // } else if (
                //   approvalStatusArray?.every((status) => status === "approved")
                // ) {
                //   status = "Approved";
                // } else if (
                //   approvalStatusArray?.every(
                //     (status) => status === "client_approved_action"
                //   )
                // ) {
                //   status = "Approved";
                // } else if (approvalStatusArray?.includes("admin_reject")) {
                //   status = "Action required";
                // } else if (approvalStatusArray?.includes("client_reject")) {
                //   status = "Action required";
                // } else if (
                //   approvalStatusArray?.every((status) => status === "pending")
                // ) {
                //   status = "Awaiting review";
                // } else if (
                //   approvalStatusArray?.every((status) => status === null)
                // ) {
                //   status = "Awaiting review";
                // } else {
                //   status = "Action required";
                // }

                let status;
                let assigned;
                const assignedStatusArray = item?.ClientChklist?.flatMap(
                  (checklist) =>
                    checklist?.ProvCheckDoc?.filter(
                      (doc) => doc && doc.DocAppr
                    )?.map((doc) =>
                      doc.DocAppr?.approval_status !== null
                        ? doc.DocAppr.approval_status
                        : "null"
                    )
                );

                // Extract reviewed_date with proper validation and conversion to Date objects
                const reviewedDates = item?.ClientChklist?.flatMap(
                  (checklist) =>
                    checklist?.ProvCheckDoc?.filter(
                      (doc) => doc?.DocAppr?.reviewed_date
                    )?.map((doc) => new Date(doc.DocAppr?.reviewed_date))
                )?.filter(Boolean); // Filter out invalid date values

                // Sort the reviewed dates to get the latest one
                const latestDate = reviewedDates?.length
                  ? new Date(Math.max(...reviewedDates))
                  : null;

                // Assign proper status based on approval and assigned status arrays
                if (
                  assignedStatusArray?.every(
                    (status) => status === "admin_reject"
                  )
                ) {
                  assigned = "Rejected";
                } else if (
                  assignedStatusArray?.every((status) => status === "approved")
                ) {
                  assigned = latestDate
                    ? moment(latestDate).format("DD/MM/YYYY")
                    : "Approved";
                } else if (
                  assignedStatusArray?.includes("null") ||
                  assignedStatusArray?.includes("client_approval_req")
                ) {
                  assigned = "Unassigned";
                }

                // Extract approval and assigned status arrays with proper null validation
                const approvalStatusArray = item?.ClientChklist?.flatMap(
                  (checklist) =>
                    checklist?.ProvCheckDoc?.filter(
                      (doc) => doc && doc.DocAppr
                    )?.map((doc) =>
                      doc.DocAppr?.approval_status !== null
                        ? doc.DocAppr.approval_status
                        : "pending"
                    )
                );
                // Validate and assign the final `status`
                // Handle empty array case
                if (!approvalStatusArray || approvalStatusArray.length === 0) {
                  status = "Action required";
                } else {
                  // Define approved statuses for easier checking
                  const approvedStatuses = ["approved", "admin_approved", "client_approved", "client_approved_action"];
                  const rejectedStatuses = ["admin_reject", "client_reject"];

                  // Check if all documents are approved (any combination of approved statuses)
                  const allApproved = approvalStatusArray.every(status => approvedStatuses.includes(status));

                  // Check if all documents are pending
                  const allPending = approvalStatusArray.every(status => status === "pending" || status === null);

                  // Check if all documents are rejected
                  const allRejected = approvalStatusArray.every(status => rejectedStatuses.includes(status));

                  // Check for mixed statuses or any rejection/pending
                  const hasRejected = approvalStatusArray.some(status => rejectedStatuses.includes(status));
                  const hasPending = approvalStatusArray.some(status => status === "pending" || status === null);
                  const hasClientApprovalReq = approvalStatusArray.includes("client_approval_req");

                  // Apply business logic based on your requirements
                  if (allApproved) {
                    status = "Approved";
                  } else if (allPending) {
                    status = "Awaiting review";
                  } else if (allRejected) {
                    status = "Action required";
                  } else if (hasClientApprovalReq) {
                    status = "Action required";
                  } else if (approvalStatusArray.length > 1 && (hasRejected || hasPending)) {
                    // Multiple documents with mixed statuses (some rejected/pending/approved)
                    status = "Action required";
                  } else {
                    // Default fallback for any other mixed scenarios
                    status = "Action required";
                  }
                }
                return (
                  <Tr key={index} onClick={() => openDialog(item)} className="cursor-pointer">
                    <Td>
                      <Tag
                        className={`${item?.docs_status == "Compliant"
                          ? "tag text-success-700 bg-success-50"
                          : "text-error-700 bg-error-50"
                          }`}
                      >
                        {item?.docs_status === "Non-compliant" &&
                          item?.billing_cycle_end_date &&
                          new Date(item.billing_cycle_end_date) < new Date() ? (
                          <>
                            Non-compliant
                            <svg
                              width="17"
                              height="16"
                              viewBox="0 0 17 16"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M4.33301 10.6668C4.33301 12.1396 5.52692 13.3335 6.99967 13.3335H9.66634C11.1391 13.3335 12.333 12.1396 12.333 10.6668C12.333 9.19407 11.1391 8.00016 9.66634 8.00016H6.99967C5.52692 8.00016 4.33301 6.80626 4.33301 5.3335C4.33301 3.86074 5.52692 2.66683 6.99967 2.66683H9.66634C11.1391 2.66683 12.333 3.86074 12.333 5.3335M8.33301 1.3335V14.6668"
                                stroke="#B42318"
                                strokeWidth="1.33333"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </>
                        ) : (
                          item?.docs_status
                        )}


                      </Tag>
                    </Td>
                    <Td className="cursor-pointer">{item?.trading_name}</Td>
                    <Td className="cursor-pointer">{item?.provClientCont?.contact_email}</Td>
                    <Td>
                      <span className="block w-full text-gray-900">
                        {" "}
                        {item?.provClientCont?.contact_phone}
                      </span>
                      <span className="block w-full text-gray-600">
                        {item?.provClientCont?.contact_first_name
                          ? item?.provClientCont?.contact_first_name
                          : "" + " " + item?.provClientCont?.contact_last_name
                            ? item?.provClientCont?.contact_last_name
                            : ""}
                      </span>
                    </Td>
                    <Td>{assigned}</Td>
                    <Td>
                      <Button onClick={() => openDialog(item)}>
                        <Tag
                          className={`badge-wrapper ${status === "Action required"
                            ? "bg-error-100 text-error-700"
                            : status === "Awaiting review"
                              ? "bg-blue-100 text-blue-700"
                              : "bg-success-50 text-success-700"
                            }`}
                        >
                          {status}
                        </Tag>
                      </Button>
                    </Td>
                  </Tr>
                );
              })}
          </TBody>
        </Table>
      </div>

      <Dialog
        isOpen={dialogIsOpen}
        onClose={onDialogClose}
        onRequestClose={onDialogClose}
      >
        <div className="flex border-b mb-5 pb-5 px-6 pt-6 items-center">
          <span className="h-12 w-12 border rounded-lg border-gray-200 flex items-center justify-center shadow-sm mr-4">
            <svg
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M20.818 7.48905L20.818 7.48906C21.2151 7.55537 21.5063 7.89888 21.5063 8.30132V21.3249C21.5063 21.7796 21.1378 22.1484 20.6828 22.1484H14.8945C14.4399 22.1484 14.0711 21.7793 14.0711 21.3249C14.0711 20.8704 14.4399 20.5013 14.8945 20.5013H19.8595L19.8594 8.99906L12.8239 7.82655V21.3249C12.8239 21.7793 12.4552 22.1484 12.0004 22.1484C11.5458 22.1484 11.1771 21.7793 11.1771 21.3249V6.85434C11.1771 6.61219 11.2835 6.38252 11.4682 6.22611C11.6528 6.06957 11.8972 6.00228 12.1357 6.04206C12.1357 6.04206 12.1357 6.04206 12.1357 6.04206L20.818 7.48905Z"
                fill="#344054"
                stroke="#0E4E9A"
                stroke-width="0.2"
              />
              <path
                d="M14.0706 17.7071C14.0706 17.2521 14.4391 16.8836 14.894 16.8836H17.7882C18.2432 16.8836 18.6117 17.2521 18.6117 17.7071V21.3247C18.6117 21.7796 18.2432 22.1483 17.7882 22.1483H14.894C14.4391 22.1483 14.0706 21.7796 14.0706 21.3247V17.7071ZM15.7176 20.5012H16.9647V18.5306H15.7176V20.5012Z"
                fill="#344054"
                stroke="#344054"
                stroke-width="0.2"
              />
              <path
                d="M5.39091 17.7071C5.39091 17.2521 5.75953 16.8836 6.21446 16.8836H9.1086C9.56355 16.8836 9.93203 17.2521 9.93203 17.7071V21.3247C9.93203 21.7796 9.56357 22.1483 9.1086 22.1483H6.21446C5.75951 22.1483 5.39091 21.7797 5.39091 21.3247V17.7071ZM7.03805 20.5012H8.28504V18.5306H7.03805V20.5012Z"
                fill="#0E4E9A"
                stroke="#0E4E9A"
                stroke-width="0.2"
              />
              <path
                d="M3.45215 3.14766L3.45226 3.14768L12.1345 4.59492C12.5315 4.6611 12.8227 5.00451 12.8227 5.40719V21.3247C12.8227 21.7795 12.4543 22.1481 11.9992 22.1481H6.21095C5.75633 22.1481 5.38764 21.779 5.38764 21.3247C5.38764 20.8704 5.75633 20.5013 6.21095 20.5013H11.1759L11.1759 6.10492L4.14038 4.93217V21.3248C4.14038 21.7791 3.7717 22.1482 3.31707 22.1482C2.86233 22.1482 2.49364 21.7791 2.49364 21.3248V3.95996C2.49364 3.71782 2.6002 3.48843 2.78471 3.33197C2.9694 3.17512 3.21377 3.10819 3.45215 3.14766Z"
                fill="#0E4E9A"
                stroke="#0E4E9A"
                stroke-width="0.2"
              />
              <path
                d="M16.9647 13.7278C16.9647 13.4728 17.1715 13.266 17.4264 13.266H18.1499C18.4049 13.266 18.6117 13.4728 18.6117 13.7278V14.4513C18.6117 14.7061 18.4049 14.9131 18.1499 14.9131H17.4264C17.1715 14.9131 16.9647 14.7061 16.9647 14.4513V13.7278Z"
                fill="#0E4E9A"
                stroke="#0E4E9A"
                stroke-width="0.2"
              />
              <path
                d="M14.0702 13.7278C14.0702 13.4728 14.277 13.266 14.532 13.266H15.2554C15.5104 13.266 15.7172 13.4728 15.7172 13.7278V14.4513C15.7172 14.7061 15.5104 14.9131 15.2554 14.9131H14.532C14.277 14.9131 14.0702 14.7062 14.0702 14.4513V13.7278Z"
                fill="#0E4E9A"
                stroke="#0E4E9A"
                stroke-width="0.2"
              />
              <path
                d="M14.0702 10.8335C14.0702 10.5787 14.277 10.3717 14.532 10.3717H15.2554C15.5104 10.3717 15.7172 10.5786 15.7172 10.8335V11.557C15.7172 11.8119 15.5104 12.0188 15.2554 12.0188H14.532C14.277 12.0188 14.0702 11.8119 14.0702 11.557V10.8335Z"
                fill="#0E4E9A"
                stroke="#0E4E9A"
                stroke-width="0.2"
              />
              <path
                d="M16.9647 10.8335C16.9647 10.5787 17.1715 10.3717 17.4264 10.3717H18.1499C18.4049 10.3717 18.6117 10.5786 18.6117 10.8335V11.557C18.6117 11.8119 18.4049 12.0188 18.1499 12.0188H17.4264C17.1715 12.0188 16.9647 11.8118 16.9647 11.557V10.8335Z"
                fill="#0E4E9A"
                stroke="#0E4E9A"
                stroke-width="0.2"
              />
              <path
                d="M8.28501 13.7278C8.28501 13.4728 8.49182 13.266 8.7468 13.266H9.47036C9.72523 13.266 9.93203 13.4728 9.93203 13.7278V14.4513C9.93203 14.7061 9.72526 14.9131 9.47036 14.9131H8.7468C8.49182 14.9131 8.28501 14.7062 8.28501 14.4513V13.7278Z"
                fill="#0E4E9A"
                stroke="#0E4E9A"
                stroke-width="0.2"
              />
              <path
                d="M5.39036 13.7278C5.39036 13.4728 5.59717 13.266 5.85215 13.266H6.57571C6.83053 13.266 7.0375 13.4728 7.0375 13.7278V14.4513C7.0375 14.7062 6.83057 14.9131 6.57571 14.9131H5.85215C5.59716 14.9131 5.39036 14.7062 5.39036 14.4513V13.7278Z"
                fill="#0E4E9A"
                stroke="#0E4E9A"
                stroke-width="0.2"
              />
              <path
                d="M5.39036 10.8335C5.39036 10.5787 5.59715 10.3717 5.85215 10.3717H6.57571C6.83055 10.3717 7.0375 10.5786 7.0375 10.8335V11.557C7.0375 11.8119 6.83057 12.0188 6.57571 12.0188H5.85215C5.59716 12.0188 5.39036 11.8119 5.39036 11.557V10.8335Z"
                fill="#0E4E9A"
                stroke="#0E4E9A"
                stroke-width="0.2"
              />
              <path
                d="M8.28501 10.8335C8.28501 10.5787 8.4918 10.3717 8.7468 10.3717H9.47036C9.72525 10.3717 9.93203 10.5787 9.93203 10.8335V11.557C9.93203 11.8118 9.72526 12.0188 9.47036 12.0188H8.7468C8.49182 12.0188 8.28501 11.8119 8.28501 11.557V10.8335Z"
                fill="#0E4E9A"
                stroke="#0E4E9A"
                stroke-width="0.2"
              />
              <path
                d="M8.28501 7.93943C8.28501 7.68461 8.4918 7.47764 8.7468 7.47764H9.47036C9.72525 7.47764 9.93203 7.68461 9.93203 7.93943V8.66299C9.93203 8.91793 9.72524 9.12478 9.47036 9.12478H8.7468C8.49184 9.12478 8.28501 8.91797 8.28501 8.66299V7.93943Z"
                fill="#0E4E9A"
                stroke="#0E4E9A"
                stroke-width="0.2"
              />
              <path
                d="M5.39036 7.93943C5.39036 7.68461 5.59715 7.47764 5.85215 7.47764H6.57571C6.83055 7.47764 7.0375 7.68457 7.0375 7.93943V8.66299C7.0375 8.91797 6.83055 9.12478 6.57571 9.12478H5.85215C5.59718 9.12478 5.39036 8.91797 5.39036 8.66299V7.93943Z"
                fill="#0E4E9A"
                stroke="#0E4E9A"
                stroke-width="0.2"
              />
            </svg>
          </span>
          <div>
            <h5 className="mb-0 text-gray-900 text-base font-semibold">
              Viewing Client
            </h5>
          </div>
        </div>
        <div className="px-4">
          <Tabs defaultValue="tab1" variant="pill">
            <div className=" bg-blue-25 border border-gray-100 p-1 rounded-lg mb-5">
              <TabList>
                <TabNav value="tab1" className="flex-1">
                  Documents
                </TabNav>
                <TabNav value="tab2" className="flex-1">
                  Client Details
                </TabNav>
                <TabNav value="tab3" className="flex-1">
                  Connected Workers
                </TabNav>
                <TabNav value="tab4" className="flex-1">
                  Accreditation
                </TabNav>
              </TabList>
            </div>
            <TabContent value="tab1" className="px-0">
              <Documents
                indivisualData={indivisualData}
                getAllinvitedData={props.getAllinvitedData}
                handleSort={props.handleSort}
              />
            </TabContent>
            <TabContent value="tab2">
              <ClientDetails indivisualData={indivisualData} />
            </TabContent>
            <TabContent value="tab3">
              <ConnectedWorkers indivisualData={indivisualData} />
            </TabContent>
            <TabContent value="tab4">
              <PdfDataView
                type={"provider"}
                provider_org_id={loginUserData?.organisation_id}
              />
            </TabContent>
          </Tabs>
        </div>
        <div className="flex dailog-footer justify-end gap-2 p-0"></div>
      </Dialog>
    </React.Fragment>
  );
};
export default ClientsList;
